export default __webpack_public_path__ + "4f3a3c9dbe78e6747ee6d62d91c0cb4f.png";